import { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { uploadImage } from '../utils';

export default function UserWriteModal({ onClose, userPosition, user, displayName }) {
  const [content, setContent] = useState('');
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async () => {
    if (!content.trim()) return;
    setLoading(true);
    try {
      let imageUrl = null;
      if (image) imageUrl = await uploadImage(image);
      await addDoc(collection(db, 'posts'), {
        content, imageUrl,
        lat: userPosition[0], lng: userPosition[1],
        uid: user.uid, displayName,
        type: 'user', category: 'user',
        createdAt: serverTimestamp(),
        expiresAt: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000),
      });
      onClose();
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
      <div style={{ background: 'white', borderRadius: '16px 16px 0 0', padding: 24, width: '100%', maxWidth: 480, display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ margin: 0, fontSize: 16 }}>지금 이 순간 공유하기 📍</h2>
          <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: 20, cursor: 'pointer' }}>✕</button>
        </div>
        <p style={{ margin: 0, fontSize: 12, color: '#999' }}>💬 {displayName} · 3일 후 자동 삭제</p>
        <textarea
          placeholder="지금 여기서 무슨 일이 있나요?"
          value={content} onChange={e => setContent(e.target.value)}
          rows={4}
          style={{ padding: '10px 12px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14, resize: 'none', fontFamily: 'sans-serif' }}
        />
        {preview && (
          <div style={{ position: 'relative' }}>
            <img src={preview} alt="" style={{ width: '100%', borderRadius: 8, maxHeight: 200, objectFit: 'cover' }} />
            <button onClick={() => { setImage(null); setPreview(null); }} style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', borderRadius: '50%', width: 24, height: 24, cursor: 'pointer', fontSize: 12 }}>✕</button>
          </div>
        )}
        <div style={{ display: 'flex', gap: 10 }}>
          <label style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: '1px solid #ddd', background: 'white', fontSize: 13, cursor: 'pointer', textAlign: 'center' }}>
            📷 사진 추가
            <input type="file" accept="image/*" onChange={handleImage} style={{ display: 'none' }} />
          </label>
          <button
            onClick={handleSubmit} disabled={loading || !content.trim()}
            style={{ flex: 2, padding: '10px 0', borderRadius: 8, border: 'none', background: content.trim() ? '#333' : '#ccc', color: 'white', fontSize: 14, cursor: content.trim() ? 'pointer' : 'default' }}
          >
            {loading ? '올리는 중...' : '📌 지도에 올리기'}
          </button>
        </div>
      </div>
    </div>
  );
}